import { ConditionsNew } from '@retail/calculus/types';

const bindingKey = (condition: ConditionsNew) =>
  `${condition.supplier?.supplierNumber ?? ''}|${condition.bindingType}|${
    condition.bindingTargetId
  }${
    condition.bindingType === 'MG_SUPPLIER_ITEM'
      ? `|${condition.bindingTargetItem?.packageType ?? ''}`
      : ''
  }`;

export const groupConditionsByBinding = (conditions: ConditionsNew[]): ConditionsNew[] => {
  const groups = new Map<string, ConditionsNew>();

  conditions.forEach((condition) => {
    const key = bindingKey(condition);
    const existing = groups.get(key);

    groups.set(
      key,
      new ConditionsNew({
        assortmentId: condition.assortmentId,
        assortmentName: condition.assortmentName,
        inDraft: (existing?.inDraft ?? true) && condition.inDraft,
        types: [...(existing?.types ?? []), ...condition.types],
        type: existing?.type ?? condition.type,
        id: existing?.id ?? condition.id,
        supplier: existing?.supplier ?? condition.supplier,
        bindingType: condition.bindingType,
        bindingTargetName: existing?.bindingTargetName || condition.bindingTargetName,
        bindingTargetId: condition.bindingTargetId,
        bindingTargetItem: existing?.bindingTargetItem ?? condition.bindingTargetItem,
        purchaseCondition: condition.purchaseCondition ?? existing?.purchaseCondition,
        freightCondition: condition.freightCondition ?? existing?.freightCondition,
        markupCondition: condition.markupCondition ?? existing?.markupCondition,
        customerMarkupCondition:
          condition.customerMarkupCondition ?? existing?.customerMarkupCondition,
        roundingCondition: condition.roundingCondition ?? existing?.roundingCondition,
        priceSourceCondition: condition.priceSourceCondition ?? existing?.priceSourceCondition,
      })
    );
  });

  return Array.from(groups.values());
};

export const getConditionBindingId = bindingKey;
